import ShareButton from './ShareButton';
import { formatEventDate } from '@/lib/formatEventDate';

/** Thin wrapper around ShareButton for events — preserves existing API. */
export default function ShareEventButton({ event }) {
  if (!event?.event_id) return null;
  const dateStr = event.event_date
    ? formatEventDate(event.event_date, { weekday: 'short', month: 'short', day: 'numeric' })
    : '';
  const venue = [event.venue_name, event.city, event.state].filter(Boolean).join(', ');
  const subtitle = [dateStr, venue].filter(Boolean).join(' @ ');

  return (
    <ShareButton
      shareApiPath={`/api/events/${event.event_id}/share`}
      title={event.title || 'Mahjong Event'}
      subtitle={subtitle}
      testId="share-event-btn"
    />
  );
}
